import { render, staticRenderFns } from "./RequiredField.vue?vue&type=template&id=c511ad82&scoped=true"
import script from "./RequiredField.vue?vue&type=script&lang=js"
export * from "./RequiredField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c511ad82",
  null
  
)

export default component.exports